module.exports = __webpack_public_path__ + "img/pg.9beac01f.svg";